import API from './api';

const WebinarService = {
  // Public endpoints
  getAllWebinars: async (status = null, limit = null) => {
    try {
      let url = '/public/webinars';
      const params = [];
      if (status) params.push(`status=${status}`);
      if (limit) params.push(`limit=${limit}`);
      if (params.length) url += '?' + params.join('&');
      const response = await API.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getWebinarBySlug: async (slug) => {
    try {
      const response = await API.get(`/public/webinars/${slug}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  registerForWebinar: async (webinarId, formData) => {
    try {
      const response = await API.post(`/public/webinars/register/${webinarId}`, formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUpcomingCount: async () => {
    try {
      const response = await API.get('/public/webinars/count');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Admin endpoints
  adminGetAllWebinars: async () => {
    try {
      const response = await API.get('/admin/webinars');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminGetWebinarById: async (id) => {
    try {
      const response = await API.get(`/admin/webinars/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminCreateWebinar: async (webinarData) => {
    try {
      const response = await API.post('/admin/webinars', webinarData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminUpdateWebinar: async (id, webinarData) => {
    try {
      const response = await API.post(`/admin/webinars/${id}`, webinarData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminDeleteWebinar: async (id) => {
    try {
      const response = await API.delete(`/admin/webinars/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminGetRegistrations: async (webinarId) => {
    try {
      const response = await API.get(`/admin/webinars/${webinarId}/registrations`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  adminMarkAttendance: async (registrationId, attended) => {
    try {
      const response = await API.post(`/admin/webinars/1/attendance/${registrationId}`, { attended });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default WebinarService;